import type { ComponentProps } from 'react';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { SectionHeader } from '../../Header';
import { HorizontalScrollRailNav } from './HorizontalScrollRailNav';

// ────────────────────────────────────────────────────────────────────────────────

export const HorizontalScrollRailHeader = (
  props: HorizontalScrollRailHeaderProps,
) => {
  const {
    heading = '',
    headerVariation,
    withoutHeaderBorder,
    ...railNavProps
  } = props;

  return (
    <View style={styles.headerWrapper}>
      <SectionHeader
        heading={heading}
        variation={headerVariation}
        withoutBorder={withoutHeaderBorder}
      >
        <HorizontalScrollRailNav {...railNavProps} />
      </SectionHeader>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerWrapper: {
    paddingBottom: theme.spacing.medium,
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type HorizontalScrollRailHeaderProps = {
  readonly heading?: string;
  readonly headerVariation?: ComponentProps<typeof SectionHeader>['variation'];
  readonly withoutHeaderBorder?: ComponentProps<
    typeof SectionHeader
  >['withoutBorder'];
} & ComponentProps<typeof HorizontalScrollRailNav>;
